import React, { useEffect, useState } from "react";
import "./logo.css";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";

function Logo({ openfrom }) {
  const [logoSrc, setLogoSrc] = useState("");

  useEffect(() => {
    const selectedTheme = localStorage.getItem("selectedTheme");
    const logoSrc =
      selectedTheme === "dark"
        ? toAbsoluteUrl(
            `/image/${process.env.REACT_APP_API_DOMAIN}/2a.png?15641555`
          )
        : toAbsoluteUrl(
            `/image/${process.env.REACT_APP_API_DOMAIN}/2.png?15641555`
          );
    setLogoSrc(logoSrc);
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center">
      <a href="/" className="logo d-flex align-items-center">
        {openfrom === "login" ? (
          <img
            src={logoSrc}
            alt="Logo"
            style={{ width: "25vh", height: "10vh" }}
          />
        ) : (
          <img src={logoSrc} alt="Logo" style={{ maxHeight: "26px" }} />
        )}
      </a>
    </div>
  );
}

export default Logo;
